import { createComponentHealth } from '@apps/admin/common/ComponentHealth';

export const [wrapWithMegaNavHealthProvider, useMegaNavHealth] = createComponentHealth('MegaNav');
